module.exports = __webpack_public_path__ + "static/media/cargas-rojo.79177672.svg";